import { render } from "./TrinketGridText.vue?vue&type=template&id=7b34a4d8&scoped=true&ts=true"
import script from "./TrinketGridText.vue?vue&type=script&lang=ts"
export * from "./TrinketGridText.vue?vue&type=script&lang=ts"

import "./TrinketGridText.vue?vue&type=style&index=0&id=7b34a4d8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b34a4d8"]])

export default __exports__